module.exports = __webpack_public_path__ + "static/media/pause.2f323b8f.png";